import React from 'react';
import styles from './SuccesfulUploadMessage.module.scss';
import classnames from 'classnames';
import { BulkUploadFile } from '../types';

interface SuccessfulUploadMessageProps {
  bulkUploadedFile?: BulkUploadFile;
}
const SuccessfulUploadMessage = ({
  bulkUploadedFile,
}: SuccessfulUploadMessageProps) => {
  return (
    <div className={classnames(styles.successfulImportLoadContainer)}>
      <div className={classnames(styles.message)}>
        <strong className={classnames(styles.label)}>
          Your file has been imported successfully!
        </strong>

        <div className="flex-row d-flex justify-content-center mt-4">
          <div
            className="flex-column mr-4 border p-3 pr-5 pl-5"
            data-testid="items_imported"
          >
            <p className="mb-0">Items imported</p>
            <strong>{bulkUploadedFile?.imported ?? ''}</strong>
          </div>
          <div
            className="flex-column border p-3 pr-5 pl-5"
            data-testid="items_skipped"
          >
            <p className="mb-0">Items ignored</p>
            <strong>{bulkUploadedFile?.skipped ?? ''}</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessfulUploadMessage;
